import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSite } from "@/contexts/SiteContext";
import { fileUrl } from "@/lib/api";


// Safe cover: use cover field; fallback to first gallery image only
function weddingCover(w) {
  if (w.cover) return w.cover;
  const g = Array.isArray(w.gallery) ? w.gallery
    : (w.gallery && typeof w.gallery === "object" ? Object.values(w.gallery) : []);
  return g[0] || "";
}

export default function Weddings() {
  const { weddings } = useSite() || {};
  const list = weddings || [];

  return (
    <div data-testid="weddings-page" className="bg-[#F7F1E8] text-[#151515] min-h-screen">
      <section className="pt-40 md:pt-48 pb-16 md:pb-24 px-6 md:px-10" data-testid="weddings-hero" data-gsap="hero">
        <div className="max-w-7xl mx-auto">
          <div className="eyebrow text-[#C99A45]" data-gsap="hero-kicker">Portfolio</div>
          <h1 className="font-serif-display text-6xl md:text-8xl mt-4 leading-[0.95]" data-gsap="hero-title">Weddings.</h1>
          <div className="gold-divider my-8"></div>
          <p className="font-serif-display italic text-2xl md:text-3xl max-w-2xl text-[#151515]/80" data-gsap="hero-subtitle">
            A collection of love stories — sacred rituals, joyful tears, and timeless portraits, all preserved as cinema.
          </p>
        </div>
      </section>

      <section className="pb-24 md:pb-32 px-6 md:px-10" data-testid="weddings-grid" data-gsap="reveal">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14" data-gsap="stagger">
          {list.map((w, i) => (
            <Link key={w.slug} to={`/weddings/${w.slug}`} data-testid={`wedding-card-${w.slug}`} className={`group block ${i % 3 === 0 ? "md:mt-20" : ""}`}>
              <div className="image-frame aspect-[4/5] bg-[#e8e2d4] gsap-image-hover" data-gsap="image">
                <img src={fileUrl(weddingCover(w))} alt={w.couple} className="w-full h-full cover-safe" loading="lazy" />
              </div>
              <div className="mt-6 flex items-start justify-between gap-6">
                <div>
                  <div className="eyebrow text-[10px] text-[#C99A45]">{w.type} · {w.location}</div>
                  <h3 className="font-serif-display text-3xl md:text-4xl mt-2 group-hover:text-[#C99A45] transition">{w.couple}</h3>
                  <p className="text-sm text-[#151515]/70 mt-3 max-w-md leading-relaxed">{w.story}</p>
                </div>
                <div className="eyebrow text-[10px] flex items-center gap-2 group-hover:text-[#C99A45] mt-3 shrink-0">
                  View <ArrowRight size={12} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <section className="py-24 md:py-32 px-6 md:px-10 bg-[#070707] text-[#F7F1E8]" data-testid="weddings-cta" data-gsap="reveal">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif-display text-4xl md:text-6xl">Planning your wedding?</h2>
          <p className="mt-4 text-[#F7F1E8]/70">Let's create something timeless together.</p>
          <Link to="/contact" className="btn-gold mt-10" data-testid="weddings-cta-btn">
            Enquire Now <ArrowRight size={14} />
          </Link>
        </div>
      </section>
    </div>
  );
}
